<template>

  <v-footer color="primary" class="onprimary--text" app :height="$vuetify.breakpoint.xs ? 50 : 64">
    <span class="wgu-footer-left" v-html="footerTextLeft"></span>
    <!-- logo section -->
    <!-- TODO find Vuetify solution -->
    <!-- TODO slot in Wegue? -->
    <v-spacer></v-spacer>

    <!-- IDS logos in the middle of the footer -->
    <v-row class="footer-middle-row">
      <v-col class="ids-middle-footer-col" align="center">
        <a href="https://www.ids-mannheim.de/" target="_blank">
          <img src="static/img/logo-ids-small-1.png" height="50" alt="IDS Logo">
        </a>
      </v-col>
      <v-col class="ids-middle-footer-col" align="center">
        <a href="https://www.konsortswd.de" target="_blank">
          <img src="static/img/Logo-KonsortSWD_kurz_weisse-Schrift-72dpi.png" height="40" alt="KonsortSWD Logo" style="padding-bottom: 6px;">
        </a>
      </v-col>
      <v-col class="ids-middle-footer-col" align="center">
        <a href="https://www.konsortswd.de/konsortswd/das-konsortium/services/qualidatanet/" target="_blank">
          <img src="static/img/QualidataNet_Logo_Negativ.png" height="50" alt="QualidataNet Logo">
        </a>
      </v-col>
    </v-row>

    <v-spacer></v-spacer>
    <div class="wgu-footer-right">
      <span v-html="footerTextRight"></span>
      <span v-if="showCopyrightYear" >&copy; IDS {{ new Date().getFullYear() }}</span>
    </div>
  </v-footer>

</template>

<script>

export default {
  name: 'wgu-app-footer',
  props: {
    footerTextLeft: { type: String, required: true },
    footerTextRight: { type: String, required: true },
    showCopyrightYear: { type: Boolean, required: false, default: true }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  /* vuetify breakpoint xs */
  @media only screen and (max-width: 600px) {
    .v-footer {
      font-size: 14px;
    }
    /* hide logos, due to missing space, otherwise imprint et al. are gone */
    .row.footer-middle-row {
      display: none;
    }
  }
  /* avoid special color for links in footer */
  .v-footer a {
    color: inherit !important;
  }

  .ids-middle-footer-col {
    max-height: 52px !important;
    padding:0 !important;
  }


</style>



// WEBPACK FOOTER //
// app/components/AppFooter.vue